const profiles = {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    setProfiles(state, payload) {
      state.items = payload;
    },
  },
  actions: {},
  getters: {},
};

export default profiles;
